var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultEmployeeProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 309,
    viewBox: "0 0 338 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_2471)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 309,
    rx: 5,
    fill: "#D9DAD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 309.302C285.405 312.104 282.728 314.819 279.972 317.439C274.539 322.617 268.812 327.413 262.822 331.798C235.892 351.526 203.65 363 169 363C134.35 363 102.109 351.526 75.1785 331.798C69.1878 327.413 63.4605 322.617 58.0282 317.439C55.2718 314.819 52.5955 312.104 50 309.302C56.4421 287.092 72.19 269.089 92.9635 261.789L143.544 244.018V234.733C137.205 230.542 131.54 225.75 126.867 222.239C118.178 215.718 112.33 205.492 110.601 193.984L107.903 176.027C99.4548 176.027 92.6287 168.433 92.6287 159.031C92.6287 152.038 96.3993 146.048 101.805 143.437C97.0828 131.113 93.6157 118.051 91.5339 104.658C90.2116 96.1724 89.4655 87.2227 91.7038 79.0399C93.9376 70.8571 99.8616 63.6775 106.849 63.5366L107.764 63.607C112.174 55.9424 119.067 50.8935 126.3 47.9752C133.533 45.0528 141.168 44.062 148.736 43.0962C151.693 42.7148 154.664 42.3334 157.644 42.0018C171.386 40.5302 186.347 40.1696 200.397 44.5263C214.452 48.883 228.029 58.6493 235.186 74.2189C240.868 86.5719 242.021 101.474 240.591 115.572C239.644 124.928 237.629 134.035 235.266 143.026C241.163 145.377 245.367 151.649 245.367 159.031C245.367 168.433 238.545 176.027 230.093 176.027L227.394 193.984C225.665 205.492 219.822 215.718 211.133 222.239C206.455 225.75 200.795 230.542 194.456 234.733V244.018L245.032 261.789C265.81 269.089 281.558 287.092 288 309.302Z",
    fill: "#909292"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_2471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 309,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultEmployeeProfile);
export default __webpack_public_path__ + "static/media/DefaultEmployeeProfile.e5d92411592fd5a9565c02d677415447.svg";
export { ForwardRef as ReactComponent };